import React from "react";

export const Contact = (props) => {
  return (
    <div>
    </div>
  );
};
